import { useCallback, useEffect, useState } from 'react';
import './App.css';
import QrScanner from './QrScanner';
import CartonResult from './CartonResult';
import { extraireToken, verifierCarton } from './verificationApi';

// Etats possibles : 'scan' (camera active), 'loading' (verification en cours),
// 'result' (carton verifie affiche), 'error' (message + bouton pour reessayer).
function App() {
  // Si l'URL porte deja un ?token=... (QR scanne par l'appareil photo natif d'un
  // telephone, qui a ouvert cette page), on demarre directement en 'loading' pour
  // eviter de monter le scanner camera et de demander une permission camera pour
  // rien avant que l'effet ci-dessous ne bascule l'etat.
  const [etat, setEtat] = useState(() => (extraireToken(window.location.href) ? 'loading' : 'scan'));
  const [carton, setCarton] = useState(null);
  const [erreur, setErreur] = useState(null);

  const verifier = useCallback(async (token) => {
    setEtat('loading');
    try {
      const resultat = await verifierCarton(token);
      setCarton(resultat);
      setEtat('result');
    } catch (e) {
      setErreur(e.message || 'Une erreur est survenue.');
      setEtat('error');
    }
  }, []);

  // Le QR imprime sur l'etiquette pointe directement vers cette appli avec
  // ?token=... : un scan avec l'appareil photo natif d'un telephone ouvre cette
  // page, qui doit alors verifier tout de suite sans repasser par le scanner
  // interne. Ne se declenche qu'une fois au chargement (dependances vides).
  useEffect(() => {
    const token = extraireToken(window.location.href);
    if (token) {
      verifier(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const recommencer = useCallback(() => {
    // Nettoie le ?token=... de l'URL : sinon un rafraichissement de page (ou une
    // nouvelle visite du meme onglet) relance la verification de l'ancien carton
    // au lieu d'ouvrir le scanner.
    window.history.replaceState(null, '', window.location.pathname);
    setCarton(null);
    setErreur(null);
    setEtat('scan');
  }, []);

  const gererScan = useCallback(
    (texteDecode) => {
      const token = extraireToken(texteDecode);
      if (!token) {
        setErreur('QR non reconnu : ce code ne contient pas une URL de vérification valide.');
        setEtat('error');
        return;
      }
      verifier(token);
    },
    [verifier]
  );

  const gererErreurCamera = useCallback((message) => {
    setErreur(message);
    setEtat('error');
  }, []);

  return (
    <div className="app">
      <header className="app-header">
        <h1>Vérification de colis</h1>
        <p>Scannez le QR imprimé sur l'étiquette du carton</p>
      </header>

      <main className="app-main">
        {etat === 'scan' && <QrScanner onScan={gererScan} onError={gererErreurCamera} />}

        {etat === 'loading' && (
          <div className="app-message">
            <div className="spinner" aria-hidden="true" />
            <p>Vérification en cours…</p>
          </div>
        )}

        {etat === 'result' && carton && (
          <CartonResult carton={carton} onScannerAutre={recommencer} />
        )}

        {etat === 'error' && (
          <div className="app-message app-message-error">
            <p>{erreur}</p>
            <button type="button" className="btn-primary" onClick={recommencer}>
              Réessayer
            </button>
          </div>
        )}
      </main>
    </div>
  );
}

export default App;
